module.exports = __webpack_public_path__ + "img/red.303c7b49.jpg";